// © Microsoft Corporation. All rights reserved.

import { DesignSystem, neutralForegroundHint, neutralLayerCard } from "@microsoft/fast-components-styles-msft";

import { applyLocalizedProperty } from "@microsoft/fast-jss-utilities";

const avatarSize = "16px";
const typingDotColor = "#6B6B6B";
const typingDotBgColor = "#F1F1F1";

export const TypingUsersStyles = (config: DesignSystem) => ({
    typingUsersContainer: {
        display: "flex",
        "align-items": "center",

        "& .cwt-typer-name": {
            display: "inline-block",
            "white-space": "pre"
        },

        "& .cwt-typing-user-images": {
            display: "flex",
            position: "relative",
            "align-content": "center",
            "flex-direction": "row",
            [applyLocalizedProperty("margin-right", "margin-left", config.direction)]: "5px",

            "& .cwt-typing-user-image": {
                display: "inline-block",
                "border-radius": "50%",
                overflow: "hidden",
                border: "3px solid ",
                "border-color": neutralLayerCard,

                "&:hover": {
                    "z-index": "3"
                },

                "& img": {
                    "border-radius": "50%",
                    "min-width": avatarSize,
                    "max-width": avatarSize,
                    height: avatarSize,
                    display: "block",
                    "align-items": "center"
                }
            },

            "& .image0": {
                [applyLocalizedProperty("margin-left", "margin-right", config.direction)]: "0",
                "z-index": "2"
            },

            "& .image1": {
                [applyLocalizedProperty("margin-left", "margin-right", config.direction)]: "-5px",
                "z-index": "1"
            },

            "& .image2": {
                [applyLocalizedProperty("margin-left", "margin-right", config.direction)]: "-5px",
                "z-index": "0"
            }
        },

        "& .cwt-typing-users-text": {
            "align-content": "center",
            "align-items": "center",
            color: neutralForegroundHint,
            display: "flex",
            "font-size": "12px",
            "white-space": "pre"
        },

        "& .cwt-icon.cwt-typing-animation": {
            overflow: "hidden",
            height: "12px",
            color: typingDotColor,
            background: typingDotBgColor,
            padding: "0 3px",
            margin: "0 5px -1px",
            "border-radius": "6px 8px"
        }
    }
});